import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { TeamCompartments, teamStorageKey } from '..';

export class TeamListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.UserRolesInitialized)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(teamStorageKey)
    private readonly cache: DataCache<TeamCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('team');
        } else {
          this.cache.reset('team');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}

export class AllTeamListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.GroupSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(teamStorageKey)
    private readonly cache: DataCache<TeamCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('allTeams');
        } else {
          this.cache.reset('allTeams');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}

export class AllTeamMetricsListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.GroupSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(teamStorageKey)
    private readonly cache: DataCache<TeamCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('allMetrics');
        } else {
          this.cache.reset('allMetrics');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
